var _circle, _g, _g2, _circle2, _g3, _g4, _g5, _g6, _g7, _circle3, _g8, _g9, _circle4, _g10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVersatile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.293,
    cy: 109.396,
    r: 15.0012,
    transform: "rotate(45 109.293 109.396)",
    fill: "url(#paint0_radial_694_1590)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_694_1590)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.738,
    cy: 110.733,
    rx: 5.45497,
    ry: 5.45497,
    transform: "rotate(-127.415 113.738 110.733)",
    fill: "#9CF2FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_694_1590)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.383,
    y: 104.729,
    width: 23.9994,
    height: 6.00059,
    rx: 3.00029,
    transform: "rotate(-135 100.383 104.729)",
    stroke: "url(#paint1_linear_694_1590)",
    strokeWidth: 6.00059,
    shapeRendering: "crispEdges"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0012,
    cy: 15.0012,
    r: 15.0012,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 54.9893 33.877)",
    fill: "url(#paint2_radial_694_1590)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_694_1590)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.45497,
    cy: 5.45497,
    rx: 5.45497,
    ry: 5.45497,
    transform: "matrix(0.794259 0.607579 0.60758 -0.794259 24.7891 30.4507)",
    fill: "#9CF2FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_694_1590)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.24057,
    width: 24.0029,
    height: 5.99707,
    rx: 2.99854,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 35.4432 39.7861)",
    stroke: "url(#paint3_radial_694_1590)",
    strokeWidth: 5.99707,
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dii_694_1590)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.5338,
    cy: 71.6362,
    r: 24.0012,
    transform: "rotate(135 71.5338 71.6362)",
    fill: "#63CADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5338,
    cy: 71.6362,
    r: 24.0012,
    transform: "rotate(135 71.5338 71.6362)",
    fill: "url(#paint4_radial_694_1590)",
    fillOpacity: 0.8
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_694_1590)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.1981,
    cy: 72.4173,
    rx: 9.20045,
    ry: 9.20045,
    transform: "rotate(-109.415 66.1981 72.4173)",
    fill: "#8CF2FD"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_694_1590)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.441,
    y: 100.487,
    width: 24.0012,
    height: 5.99883,
    rx: 2.99941,
    transform: "rotate(-45 38.441 100.487)",
    stroke: "url(#paint5_radial_694_1590)",
    strokeWidth: 5.99883,
    shapeRendering: "crispEdges"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7744,
    cy: 109.396,
    r: 15.0012,
    transform: "rotate(135 33.7744 109.396)",
    fill: "url(#paint6_radial_694_1590)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_694_1590)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.4361,
    cy: 113.841,
    rx: 5.45497,
    ry: 5.45497,
    transform: "rotate(-37.4147 32.4361 113.841)",
    fill: "#9CF2FF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_694_1590)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 4.24181,
    width: 24.0012,
    height: 5.99883,
    rx: 2.99941,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 97.4869 35.4421)",
    stroke: "url(#paint7_radial_694_1590)",
    strokeWidth: 5.99883,
    shapeRendering: "crispEdges"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0012,
    cy: 15.0012,
    r: 15.0012,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 109.396 54.9893)",
    fill: "url(#paint8_radial_694_1590)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_694_1590)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.45497,
    cy: 5.45497,
    rx: 5.45497,
    ry: 5.45497,
    transform: "matrix(-0.607579 0.794259 0.794259 0.60758 112.822 24.7886)",
    fill: "#9CF2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_694_1590",
    x: 98.1014,
    y: 95.0965,
    width: 31.2738,
    height: 31.2738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_1590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_694_1590",
    x: 71.6553,
    y: 69.7578,
    width: 48.7285,
    height: 48.7285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_694_1590",
    x: 16.7986,
    y: 13.7952,
    width: 31.2748,
    height: 31.2743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_1590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_694_1590",
    x: 26.6855,
    y: 24.7876,
    width: 48.7256,
    height: 48.7261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dii_694_1590",
    x: 41.5322,
    y: 40.1353,
    width: 63.0029,
    height: 63.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1590",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_694_1590"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: -2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_694_1590",
    result: "effect3_innerShadow_694_1590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_694_1590",
    x: 46.8133,
    y: 53.0325,
    width: 38.7699,
    height: 38.7694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_1590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_694_1590",
    x: 26.6836,
    y: 69.7583,
    width: 48.7275,
    height: 48.7275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_694_1590",
    x: 16.7986,
    y: 98.2034,
    width: 31.2748,
    height: 31.2743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_1590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_694_1590",
    x: 71.7578,
    y: 24.6846,
    width: 48.7275,
    height: 48.7271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_694_1590",
    x: 98.2039,
    y: 16.7986,
    width: 31.2738,
    height: 31.2738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_1590"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_694_1590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.644 98.3436) rotate(104.47) scale(27.1662 37.1145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#3A78B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_694_1590",
    x1: 151.204,
    y1: 115.159,
    x2: 100.792,
    y2: 107.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_694_1590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3521 3.9493) rotate(104.47) scale(27.1662 37.1145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#3A78B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_694_1590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3546 7.29121) rotate(-177.879) scale(34.389 18.0277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_694_1590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.2099 53.4663) rotate(146.296) scale(50.2583 64.2523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_694_1590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.5538 107.78) rotate(-177.878) scale(34.389 18.033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_694_1590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.1253 98.3436) rotate(104.47) scale(27.1662 37.1145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#3A78B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_694_1590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3546 7.29335) rotate(-177.878) scale(34.389 18.033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_694_1590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3521 3.9493) rotate(104.47) scale(27.1662 37.1145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#3A78B1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersatile);
export default __webpack_public_path__ + "static/media/versatile.8875242c.svg";
export { ForwardRef as ReactComponent };